module.exports = __webpack_public_path__ + "img/03-3-5可追溯.59500d1e.svg";